// import { setToken, removeToken } from '@/util/auth'
import { setStore, getStore } from '@/util/store'
import { isURL } from '@/util/validate'
import { encryption, deepClone } from '@/util/util'
import webiste from '@/util/website'
import { loginByUsername, getUserInfo, getMenu, logout, getMenuAll, RefeshToken, getModule } from '@/api/user'


function addPath(ele, first) {
    const propsConfig = webiste.menu.props;
    const propsDefault = {
        label: propsConfig.label || 'label',
        path: propsConfig.path || 'path',
        icon: propsConfig.icon || 'icon',
        children: propsConfig.children || 'children'
    }
    const isChild = ele[propsDefault.children] && ele[propsDefault.children].length !== 0;
    if (!isChild && first) {
        ele[propsDefault.path] = ele[propsDefault.path] + '/index'
        return
    }
    ele[propsDefault.children].forEach(child => {
        if (!isURL(child[propsDefault.path])) {
            child[propsDefault.path] = `${ele[propsDefault.path]}/${child[propsDefault.path]?child[propsDefault.path]:'index'}`
        }
        addPath(child);
    })
}
const user = {
    state: {
        userInfo: {},
        permission: {},
        roles: [],
        menu: getStore({ name: 'menu' }) || [],
		module: getStore({ name: 'module' }) || [],
		currentActiveModule: '',
		activeKey: '',
        menuAll: getStore({ name: 'menuAll' }) || [],
        token: getStore({ name: 'token' }) || '',
		isTokenRefresh: false
    },
    actions: {
        //根据用户名登录
        LoginByUsername({ commit }, userInfo) {
            const user = encryption({
                data: userInfo,
                type: 'Aes',
                param: ['password']
            });
            return new Promise((resolve, reject) => {
				let clientId = getStore({ name: 'x-client' });
				user.clientId = clientId;
                loginByUsername(user).then(res => {
					const data = res.data.data;
					commit('SET_TOKEN', data);
					commit('DEL_ALL_TAG');
					commit('CLEAR_LOCK');
						// setToken(data);
                    resolve();
                }).catch(error => {
                    reject(error);
                })
            })
        },
        //根据手机号登录
        LoginByPhone({ commit }, userInfo) {
            return new Promise((resolve, reject) => {
                loginByUsername(userInfo.phone, userInfo.code).then(res => {
                    const data = res.data.data;
                    commit('SET_TOKEN', data);
                    commit('DEL_ALL_TAG');
                    commit('CLEAR_LOCK');
                    // setToken(data);
                    resolve();
                }).catch(error => {
                    reject(error)
                })
            })
        },
        GetUserInfo({ commit }) {
            return new Promise((resolve, reject) => {
                getUserInfo().then((res) => {
                    const data = res.data.data;
                    commit('SET_USERIFNO', data.userInfo);
                    commit('SET_ROLES', data.roles);
                    commit('SET_PERMISSION', data.permission)
                    resolve(data);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        //刷新token
        RefeshToken({ commit, state }) {
			//获取时间
			let token = state.token;
			if(state.isTokenRefresh) {
				return;
			}
			
			state.isTokenRefresh = true;
			
            return new Promise((resolve, reject) => {
                RefeshToken(token.refreshTokenValue).then(res => {
                    const data = res.data.data;
                    commit('SET_TOKEN', data);
                    // setToken(data);
					state.isTokenRefresh = false;
                    resolve(data);
                }).catch(error => {
					console.log('刷新TOKEN失败');
					state.isTokenRefresh = false;
                    reject(error)
                })
            })
        },
        // 登出
        LogOut({ commit }) {
            return new Promise((resolve, reject) => {
                logout().then(() => {
                    commit('SET_TOKEN', '')
                    commit('SET_MENU', [])
                    commit('SET_ROLES', [])
                    commit('DEL_ALL_TAG');
                    commit('CLEAR_LOCK');
                    // removeToken()
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },
        //注销session
        FedLogOut({ commit }) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '')
                commit('SET_MENU', [])
                commit('SET_ROLES', [])
                commit('DEL_ALL_TAG');
                commit('CLEAR_LOCK');
                // removeToken()
                resolve()
            })
        },
        //获取系统菜单
        GetMenu({ commit, state }, parentId) {
			return new Promise(resolve => {
				commit('SET_MENU', parentId);
				resolve(state.menu);
			})
        },

        //获取全部菜单
        GetMenuAll({ commit }) {
            return new Promise(resolve => {
                getMenuAll().then((res) => {
                    const data = res.data.data;
					commit('SET_MODULE', data.modules);
                    commit('SET_MENU_ALL', data.menusMap);
                    resolve(data);
                })
            })
        },
		
		/**
		 * 激活模块
		 */
		ActiveModule({commit}, activeId) {
			commit('SET_ACTIVE_MODULE', activeId);
		},
		/**
		 * 修改密码是否已经被初始过
		 */
		InitPwd({commit}) {
			commit('SET_INIT_PWD');
		}
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token;
            setStore({ name: 'token', content: state.token, type: 'session' })
        },
        SET_USERIFNO: (state, userInfo) => {
            state.userInfo = userInfo;
        },
        SET_MENU: (state, parentId) => {
			let menusMap = state.menuAll;
			let menus = menusMap[parentId];
            state.menu = menus
            setStore({ name: 'menu', content: state.menu, type: 'session' })
        },
		SET_MODULE: (state, module) => {
		    state.module = module
		    setStore({ name: 'module', content: state.module, type: 'session' })
		},
        SET_MENU_ALL: (state, menuAll) => {
            state.menuAll = menuAll;
			setStore({ name: 'menuAll', content: state.menuAll, type: 'session' })
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles;
        },
        SET_PERMISSION: (state, permission) => {
            state.permission = {};
			if(permission) {
				permission.forEach(ele => {
				    state.permission[ele] = true;
				});
			}
        },
		SET_ACTIVE_MODULE: (state, activeId) => {
            state.currentActiveModule = activeId;
        },
		SET_INIT_PWD: (state) => {
			state.userInfo.initPwd = 1;
		}
    }

}
export default user


// WEBPACK FOOTER //
// ./src/vuex/modules/user.js